import { useEffect } from 'react';

export type PollUntilCompletedProps = {
  isCompleted: boolean;
  skip: boolean;
  refetchQuery: () => void;
  onCompleted?: (() => void) | undefined;
  interval?: number;
};

const defaultProps = {
  isCompleted: true,
  skip: true,
  refetchQuery: () => {},
  interval: 3000,
} satisfies PollUntilCompletedProps;

export function usePollUntilCompleted(
  props: PollUntilCompletedProps | undefined
) {
  'use memo';
  const {
    isCompleted,
    skip,
    refetchQuery,
    interval = 3000,
  } = props || defaultProps;

  useEffect(() => {
    if (isCompleted && props?.onCompleted) {
      props.onCompleted();
    }
  }, [isCompleted, props?.onCompleted]);

  // refetch query every 3 seconds until all sync statuses are "completed"
  useEffect(() => {
    const timeout = setInterval(() => {
      if (!isCompleted && !skip) {
        refetchQuery();
      }
    }, interval);

    return () => clearInterval(timeout);
  }, [refetchQuery, skip, interval, isCompleted]);
}
